export default __webpack_public_path__ + "static/onboarding.dark-5bc9ba1250be8bff63a3565d8c49da9be6d1d83e289de3bbcf55597608632315.png";